module.exports = __webpack_public_path__ + "static/media/1_en.8eba5da8.png";